import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { SesionActivaUsuarioService } from 'src/app/services/sesion-activa-usuario.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { SesionActivaUsuario } from 'src/app/shared/object/sesion-activa-usuario.interface';
import { usuario } from 'src/app/shared/object/usuario.model';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { Mensaje, TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';
import Swal from 'sweetalert2';

@Component({
  templateUrl: './sesiones-activas-usuarios.component.html',
  styleUrls: ['./sesiones-activas-usuarios.component.scss']
})
export class SesionesActivasUsuariosComponent implements OnInit {

  rut_empresa: number;
  formFiltro: FormGroup;
  sesionesActivas: SesionActivaUsuario[];

  optionUsuarios: any[];

  constructor(
    private fb: FormBuilder,
    private sesionActivaUsuarioService: SesionActivaUsuarioService,
    private usuarioService: UsuarioService,
    private toastService: ToastService,
    private accesoLocalstorage: SecurityService,
    private validadoreService: ValidadoresService,
  ) {
    this.sesionesActivas = [];
    this.optionUsuarios = [];
    this.rut_empresa = Number(this.accesoLocalstorage.getRutEmpresa());
  }

  get ctrlRutUsuario(): FormControl | undefined {
    return this.formFiltro.get('rutUsuario') as FormControl;
  }

  ngOnInit() {
    this.configurarForm();
    this.obtenerSesiones({
      paginaActual: 1,
      cantidadRegistrosPorPagina: -1,
    });
    this.obtenerUsuarios();
  }

  configurarForm() {
    this.formFiltro = this.fb.group({
      rutUsuario: [null],
    });
  }

  obtenerSesiones(inputParams: {
    entidad?: SesionActivaUsuario,
    paginaActual: number,
    cantidadRegistrosPorPagina: number,
  }) {
    this.sesionActivaUsuarioService.obtenerTodaSesionesActivas(inputParams, (response: any) => {
      if (response.mensajes && response.mensajes.some((m: Mensaje) => m.tipo === TipoMensaje.ERROR)) {
        this.toastService.error('Error al obtener las sesiones activas', response.mensajes[0].texto);
        return;
      }
      const registros = response.respuesta.registros as SesionActivaUsuario[];
      this.sesionesActivas = registros.map(s => ({
        ...s,
        rutFormato: this.validadoreService._enmascaraRut(s.rut_usuario.toString()),
        fecha_creacion: this.obtenerFechaUTCtoDate(s.fecha_creacion),
        fecha_ultima_actividad: this.obtenerFechaUTCtoDate(s.fecha_ultima_actividad),
        fecha_expiracion: this.obtenerFechaUTCtoDate(s.fecha_expiracion),
      }));
    });
  }


  obtenerUsuarios() {
    const inputParams = {
      entidad: {
        rut_usuario: 0,
        login: '',
        password: '',
        fecha_creacion: new Date(),
        fecha_modificacion: new Date(),
        mail: '',
        activo: true,
        nombre_completo: "",
        flag_cambioclave: true
      },
      rut_empresa: this.rut_empresa,
      roles_codigo: [],
      sucursal_codigo: []
    };

    this.usuarioService.obtenerUsuariosxEmpresa(inputParams, ({ mensajes, respuesta }) => {
      if (respuesta === null || respuesta.registros.length === 0) return;

      this.optionUsuarios = (respuesta.registros as usuario[]).filter(u => u.activo)
      .map(usuario => ({
        value: usuario.rut_usuario,
        label: usuario.nombre_completo.toUpperCase()
      }));
    })
  }

  limpiarFiltros(): void {
    this.formFiltro.reset({
      rutUsuario: null,
    });
    this.buscar();
  }

  buscar() {
    const nowISO = new Date().toISOString();
    const sesion: SesionActivaUsuario = {
      fecha_creacion: nowISO,
      fecha_ultima_actividad: nowISO,
      fecha_expiracion: nowISO,
      nombreUsuario: '',
      rut_usuario: this.ctrlRutUsuario.value,
      token_refresco: '',
      user_agent: '',
      ip_address: '',
      navegador: '',
      sistemaOperativo: '',
      tipoDispositivo: '',
    }
    const inputParams = {
      entidad: sesion,
      paginaActual: 1,
      cantidadRegistrosPorPagina: -1,
    }
    this.obtenerSesiones(inputParams)
  }

  validarEliminar(sesion: SesionActivaUsuario) {
    Swal.fire({
      title: '¿Estás seguro?',
      text: `Se eliminará la sesión activa para el usuario ${sesion.nombreUsuario} - IP: ${sesion.ip_address} - Dispositivo: ${sesion.tipoDispositivo}.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.eliminarSesion(sesion);
      }
    });
  }

  private eliminarSesion(sesion: SesionActivaUsuario) {
    const sesionAny = sesion as any
    const {__typename, rutFormato, ...entidad} = sesionAny; 
    const inputParams = {
      entidad,
    }
    console.log('inputParams', inputParams)
    this.sesionActivaUsuarioService.eliminarSesion(inputParams, (mensajes: Mensaje[]) => {
      if (mensajes.some(m => m.tipo === TipoMensaje.ERROR)) {
        this.toastService.error('Error al eliminar la sesión activa', mensajes[0].texto);
        return;
      }
      this.toastService.success('Sesión activa eliminada correctamente');
      this.buscar();
    })
  }

  private obtenerFechaUTCtoDate(fechaUTC: string): string {
    const fecha = fechaUTC.endsWith('Z') ? fechaUTC : fechaUTC + 'Z';
    return fecha;
  }
}
